<template>
    <v-card>
        <v-img height="80" src="@/assets/images/fondo1.png">
            <v-row class="pa-4" align="center" justify="center">
                <v-col fluid>
                    <v-list-item-avatar color="purple lighten-3" size="40" class="ma-0">
                        <v-icon size="30">class</v-icon>
                    </v-list-item-avatar>
                    <span class="headline black--text ma-4">Modalidad Titulación</span>
                    <v-btn @click.prevent="fuAdd" color="primary"><v-icon>add</v-icon> Agregar</v-btn>
                </v-col>
            </v-row>
        </v-img>
        <v-dialog v-model="dPriAlumnoModalDialog" persistent max-width="900px">
            <v-card>
                <v-card-title style="background-color:#455A64">
                    <v-form ref="refPriAlumno">
                        <v-row fluid>
                            <v-col cols="9" xm="12" sm="9" md="9" class="pa-1">
                                <v-text-field @keyup.enter="fuPriAlumnoSearch" v-model="dDNINombre" label="DNI o Codigo o Nombre" outlined prepend-inner-icon="credit_card" clearable :rules="[v => !!v || 'El campo es requerido']" :maxlength="120" counter autocomplete="off"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-btn @click="fuPriAlumnoSearch" :loading="dPriAlumnoTable.loading" color="blue-grey" dark x-large>
                                    <v-icon large left>search</v-icon> Buscar por {{campoTipo}}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-title>
                <v-data-table
                    v-model="dPriAlumnoTable.selected"
                    :headers="dPriAlumnoTable.headers"
                    :items="dPriAlumnos"
                    :loading="dPriAlumnoTable.loading"
                    single-select
                    item-key="IdAlumno"
                    show-select
                    class="elevation-1">
                    <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                </v-data-table>
                <v-card-actions class="blue-grey darken-2">
                    <v-btn @click="fuPriAlumnoSelected()" color="green" dark><v-icon>check</v-icon> Seleccionar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="dPriAlumnoModalDialog = false" color="grey darken-4" dark><v-icon>close</v-icon> Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-tabs v-model="dTab" :background-color="dIdTitulacionModalidad ? 'warning':'primary'">
            <v-tab @click="dIsSearch=true; dIdTitulacionModalidad=null;" href='#tab-1'><v-icon left>search</v-icon>Buscar</v-tab>
            <v-tab v-if="!dIsSearch" href='#tab-2'>{{ dIdTitulacionModalidad ? 'EDITAR':'AGREGAR'}}</v-tab>
            <v-tab-item value='tab-1'>
                <v-form>
                    <v-container fluid>
                        <v-row fluid>
                            <v-col cols="12" sm="5" md="4" lg="3" class="pa-0">
                                <v-menu
                                    v-model="dFInicioMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dFInicio"
                                            label="Fecha Inicio"
                                            prepend-inner-icon="event_note"
                                            readonly
                                            filled
                                            :disabled="dIsUpdating"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dFInicio"
                                        @input="dFInicioMenu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="3" class="pa-0">
                                <v-menu
                                    v-model="dFFinMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dFFin"
                                            label="Fecha Fin"
                                            prepend-inner-icon="event_note"
                                            readonly
                                            filled
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dFFin"
                                        @input="dFFinMenu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="3" md="3" lg="2" class="pa-0">
                                <v-select v-model="dEstado" label="Estado"
                                    :items="['', 'INCOMPLETO','PENDIENTE','PROGRAMADO','FINALIZADO','ELIMINADO']"
                                    filled prepend-inner-icon="invert_colors"></v-select>
                            </v-col>
                            <v-col cols="12" sm="1" md="2" lg="2" class="pa-0">
                                <v-btn @click.prevent="fuTtltitulacionmodalidadBydocumentoEstadoByFechas" :loading="dTable.loading" color="blue-grey" dark x-large><v-icon large left>search</v-icon> Buscar</v-btn>
                            </v-col>
                            <v-col cols="12" sm="1" md="2" lg="2" class="pa-0">
                                <v-btn @click="dPriAlumnoModalDialog = true; dIsSearchTitulacionModalidad=true" color="blue-grey" dark x-large><v-icon large left>search</v-icon> Buscar Alumno</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                <v-data-table :headers="dTable.headers" :items="dTtlTitulacionModalidads" :loading="dTable.loading" :search="dTable.search" class="elevation-1">
                    <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                    <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-menu bottom offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-list-item-title><v-btn @click="fuGet(item.idTitulacionModalidad)" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                                </v-list-item>
                                <v-list-item v-if="item.ttltitulos.length==0 && item.estadoNota=='APROBADO' && item.documentoEstado=='FINALIZADO'">
                                    <v-list-item-title><v-btn @click="$router.push(`/Titulo/${item.idTitulacionModalidad}`);" color="purple" block><v-icon>school</v-icon> Generar Titulo</v-btn></v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>
            </v-tab-item>
            <v-tab-item value='tab-2'>
                <v-row>
                    <v-col cols="3">
                        <v-card>
                            <v-img src="@/assets/images/fondo1.png" height="150px">
                                <v-app-bar flat color="rgba(0, 0, 0, 0)">
                                    <v-toolbar-title class="title white--text pl-0">Alumno</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="dPriAlumnoModalDialog = true" rounded x-small dark color="blue-grey">
                                        <v-icon>search</v-icon> Buscar
                                    </v-btn>
                                </v-app-bar>
                                <v-row justify="space-around">
                                    <v-avatar size="80">
                                        <img v-if="dPriAlumno.Sexo=='F'" src="@/assets/images/user2.jpg" alt="Alumno">
                                        <img v-else src="@/assets/images/user1.jpg" alt="Postulante">
                                    </v-avatar>
                                </v-row>
                            </v-img>
                            <v-list two-line v-if="dPriAlumno.Alumno">
                                <v-list-item>
                                    <v-list-item-icon><v-icon>person</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-subtitle>{{dPriAlumno.Alumno}}</v-list-item-subtitle><v-list-item-subtitle>Apellidos y Nombres</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon><v-icon>bookmark</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-title>{{dPriAlumno.Servicio}}</v-list-item-title><v-list-item-subtitle>Carrera</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon><v-icon>credit_card</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-title>{{dPriAlumno.DNI}}</v-list-item-title><v-list-item-subtitle>DNI</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon><v-icon>qr_code_2</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-title><v-chip color="success" dark>{{dPriAlumno.Codigo}}</v-chip></v-list-item-title><v-list-item-subtitle>Codigo</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                    <v-col cols="9">
                        <v-form ref="refMain">
                            <v-card color="blue-grey" dark flat :loading="dIsUpdating">
                                <v-card-text fluid>
                                    <v-row>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-select label="*Modalidad Tipo" v-model="dTtlTitulacionModalidad.idModalidadTipo"
                                                :items="dTtlModalidadTipos"  item-value="idModalidadTipo" item-text="modalidadTipo"  persistent-hint
                                                filled prepend-inner-icon="invert_colors" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-text-field v-model="dTtlTitulacionModalidad.actaSustentacion" label="Acta de Sustentación" filled prepend-inner-icon="book" :disabled="dIsUpdating" :maxlength="255" autocomplete="off"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-text-field v-model="dTtlTitulacionModalidad.nroFut" label="*Nro de FUT" filled prepend-inner-icon="receipt" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 255 caracteres.']" :maxlength="255" autocomplete="off"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-select v-model="dTtlTitulacionModalidad.documentoEstado" label="Estado del Documento" :items="['INCOMPLETO','PENDIENTE','PROGRAMADO','FINALIZADO','ELIMINADO']" filled prepend-inner-icon="import_contacts" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-menu
                                                v-model="dFechaMenu"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="dTtlTitulacionModalidad.fechaProgramado"
                                                        label="Fecha Programada"
                                                        prepend-inner-icon="event_note"
                                                        readonly filled
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="dTtlTitulacionModalidad.fechaProgramado"
                                                    @input="dFechaMenu = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-text-field v-model="dTtlTitulacionModalidad.notaFinal" label="Nota Final" filled type="number" :disabled="dIsUpdating" prepend-inner-icon="exposure" :maxlength="2" autocomplete="off"/>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-select v-model="dTtlTitulacionModalidad.estadoNota" label="Estado de Nota" :items="['APROBADO','DESAPROBADO']" filled prepend-inner-icon="thumbs_up_down" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="6" md="5" class="pa-1">
                                            <v-combobox label="Personal Responsable" v-model="dTtlTitulacionModalidad.personalResponsable"
                                                :items="dPriPersonals" item-value="Personal" item-text="Personal" :return-object="false"
                                                filled prepend-inner-icon="assignment_ind" :disabled="dIsUpdating"></v-combobox>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="6" md="7" class="pa-1">
                                            <v-textarea v-model="dTtlTitulacionModalidad.observacion"
                                                label="Observación" auto-grow filled rows="2" row-height="15" :disabled="dIsUpdating" prepend-inner-icon="post_add"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-btn @click.prevent="fuSave" :loading="dIsUpdating" :color="dIdTitulacionModalidad ? 'warning':'primary'" ><v-icon>save</v-icon> Guardar</v-btn>
                                </v-card-actions>
                                <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
                                    <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
                                </v-snackbar>
                            </v-card>
                        </v-form>
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs>
    </v-card>    
</template>

<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
    name: 'TitulacionModalidad',
    mounted(){
        //this.fuTtltitulacionmodalidadBydocumentoEstadoByFechas();
        this.fuLoad();
    },
    data: () => ({
        dDNINombre:'',
        dEstado: 'INCOMPLETO',
        dFechaMenu: false,
        dFInicio: moment().subtract(90,'d').format('YYYY-MM-DD'),
        dFInicioMenu: false,
        dFFin: moment().format('YYYY-MM-DD'),
        dFFinMenu: false,
        dIdTitulacionModalidad: null,
        dIsUpdating: false,
        dIsSearch: true,
        dIsSearchTitulacionModalidad: false,
        dPriAlumno: {
            DNI: '',
            Alumno: '',
            Sexo: '',
            Telefono: '',
            Codigo: '',
            Celular: '',
            Servicio: ''
        },
        dPriAlumnoDefault: {
            DNI: '',
            Alumno: '',
            Sexo: '',
            Telefono: '',
            Codigo: '',
            Celular: '',
            Servicio: ''
        },
        dPriAlumnos: [],
        dPriAlumnoModalDialog: false,
        dPriAlumnoTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'IdAlumno', text: 'IdAlumno', align: ' d-none'},
                {value: 'Alumno', text: 'Alumno'},
                {value: 'DNI', text: 'DNI', align: 'center', sortable: false},
                {value: 'Codigo', text: 'Codigo'},
                {value: 'priservicio.Iniciales', text: 'Carrera', align: 'center', sortable: false},
                {value: 'Celular', text: 'Celular', align: 'center', sortable: false},
                {value: 'Telefono', text: 'Telefono', align: 'center', sortable: false},
                {value: 'Sexo', text: 'Sexo', align: ' d-none'},
            ],
            loading: false,
            selected: []
        },
        dPriPersonals: [],
        dSnackbar: false,
        dTab:0,
        dTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'idTitulacionModalidad', text: 'idTitulacionModalidad', align: ' d-none'},
                {value: 'fechaRegistro', text: 'F. Registro'},
                {value: 'fechaProgramado', text: 'F. Programado'},
                {value: 'prialumno.Alumno', text: 'Alumno'},
                {value: 'ttlmodalidadtipo.modalidadTipo', text: 'Tipo'},
                {value: 'documentoEstado', text: 'Estado'},
                {value: 'notaFinal', text: 'Nota Final'},
                {value: 'estadoNota', text: 'Aprobado?'}
            ],
            loading: false,
            search: null,
        },
        dTtlModalidadTipos: [],
        dTtlTitulacionModalidads: [],
        dTtlTitulacionModalidad: {
            documentoEstado: 'INCOMPLETO',
            notaFinal: '0',
            estadoNota: 'DESAPROBADO',
            personalResponsable: '',
            fechaProgramado: '',
            actaSustentacion: '',
            nroFut: '',
            observacion: '',
            IdAlumno: '',
            IdPersonal: '',
            idModalidadTipo: '',
        },
        dTtlTitulacionModalidadDefault: {
            documentoEstado: 'INCOMPLETO',
            notaFinal: '0',
            estadoNota: 'DESAPROBADO',
            personalResponsable: '',
            fechaProgramado: '',
            actaSustentacion: '',
            nroFut: '',
            observacion: '',
            IdAlumno: '',
            IdPersonal: '',
            idModalidadTipo: '',
        }
    }),
    methods: {
        fuAdd(){
            this.dTtlTitulacionModalidad = Object.assign({}, this.dTtlTitulacionModalidadDefault);
            this.dPriAlumno = Object.assign({}, this.dPriAlumnoDefault);
            this.dIdTitulacionModalidad=null;
            this.dIsSearch=false;
            this.dTab='tab-2';
        },
        async fuLoad(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query load{
                        ttlmodalidadtipoByestado(estado:1){
                            idModalidadTipo
                            modalidadTipo
                        }
                        pripersonalByEstado(Estado:1){
                            Personal
                        }
                    }`
                })
                console.log(response.data.ttlmodalidadtipoByestado);
                this.dTtlModalidadTipos = response.data.ttlmodalidadtipoByestado;
                this.dPriPersonals = response.data.pripersonalByEstado;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
            }
        },
        async fuTtltitulacionmodalidadByIdAlumno(vIdAlumno){
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumno($IdAlumno: ID!){
                        prialumno(IdAlumno:$IdAlumno){
                            ttltitulacionmodalidads{
                                idTitulacionModalidad
                                fechaRegistro
                                fechaProgramado
                                documentoEstado
                                notaFinal
                                estadoNota
                                prialumno{
                                    Alumno
                                }
                                ttlmodalidadtipo{
                                    modalidadTipo
                                }
                                ttltitulos{
                                    idTitulo
                                }
                            }
                        }
                    }`,
                    variables: {
                        IdAlumno: vIdAlumno
                    }
                })
                this.dTtlTitulacionModalidads = [];
                this.dTtlTitulacionModalidads = response.data.prialumno.ttltitulacionmodalidads;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dTable.loading = false
            }
        },
        async fuTtltitulacionmodalidadBydocumentoEstadoByFechas(){
            this.dTable.loading = true;
            let vFInicio =this.dFInicio.substring(0,10).split("-").join("");
            let vFFin =this.dFFin.substring(0,10).split("-").join("");
            try {
                const response = await this.$apollo.query({
                    query: gql`query ttltitulacionmodalidadBydocumentoEstadoByFechas($documentoEstado: String, $FInicio: String!, $FFin: String!, $token: String){
                        ttltitulacionmodalidadBydocumentoEstadoByFechas(documentoEstado:$documentoEstado, FInicio:$FInicio, FFin:$FFin, token: $token){
                            idTitulacionModalidad
                            fechaRegistro
                            fechaProgramado
                            documentoEstado
                            notaFinal
                            estadoNota
                            prialumno{
                                Alumno
                            }
                            ttlmodalidadtipo{
                                modalidadTipo
                            }
                            ttltitulos{
                                idTitulo
                            }
                        }
                    }`,
                    variables: {
                        documentoEstado: this.dEstado,
                        FInicio: vFInicio,
                        FFin: vFFin,
                        token: new Date().toISOString()
                    }
                })
                console.log(response.data.ttltitulacionmodalidadBydocumentoEstadoByFechas);
                this.dTtlTitulacionModalidads = [];
                this.dTtlTitulacionModalidads = response.data.ttltitulacionmodalidadBydocumentoEstadoByFechas;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dTable.loading = false
            }
        },
        fuPriAlumnoSearch(){
            if(this.dDNINombre==''){
                this.dSnackbar = true;
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    this.fuPrialumnoByDNI(this.dDNINombre)
                else{
                    if(this.dDNINombre.length==9 && !isNaN(this.dDNINombre.substring(0,5)))
                        this.fuPrialumnoByCodigo(this.dDNINombre)
                    else
                        this.fuPrialumnoByAlumno(this.dDNINombre)
                }
            }
        },
        async fuPrialumnoByCodigo(pCodigo) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByCodigo($Codigo: String!){
                        prialumnoByCodigo(Codigo: $Codigo){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Telefono
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Codigo: pCodigo
                    }
                })
                console.log(response.data.prialumnoByCodigo);
                this.dPriAlumnos = [];
                this.dPriAlumnos.push(response.data.prialumnoByCodigo);
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        async fuPrialumnoByDNI(pDni) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByDNI($DNI: String!){
                        prialumnoByDNI(DNI: $DNI){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Telefono
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        DNI: pDni
                    }
                })
                console.log(response.data.prialumnoByDNI);
                this.dPriAlumnos = response.data.prialumnoByDNI;
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        async fuPrialumnoByAlumno(pAlumno) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByAlumno($Alumno: String!){
                        prialumnoByAlumno(Alumno: $Alumno){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Telefono
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Alumno: pAlumno
                    }
                })
                console.log(response.data.prialumnoByAlumno);
                this.dPriAlumnos = response.data.prialumnoByAlumno;
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        fuPriAlumnoSelected(){
            if(!this.dPriAlumnoTable.selected){
                Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
            } else {
                if(this.dPriAlumnoTable.selected.length==0)
                    Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
                else{
                    if(this.dIsSearchTitulacionModalidad){
                        this.fuTtltitulacionmodalidadByIdAlumno(this.dPriAlumnoTable.selected[0].IdAlumno);
                        this.dIsSearchTitulacionModalidad=false;
                    } else {
                        this.dTtlTitulacionModalidad.IdAlumno = this.dPriAlumnoTable.selected[0].IdAlumno;
                        this.dPriAlumno.DNI = this.dPriAlumnoTable.selected[0].DNI;
                        this.dPriAlumno.Alumno = this.dPriAlumnoTable.selected[0].Alumno;
                        this.dPriAlumno.Sexo = this.dPriAlumnoTable.selected[0].Sexo;
                        this.dPriAlumno.Telefono = this.dPriAlumnoTable.selected[0].Telefono;
                        this.dPriAlumno.Codigo = this.dPriAlumnoTable.selected[0].Codigo;
                        this.dPriAlumno.Celular = this.dPriAlumnoTable.selected[0].Celular;
                        this.dPriAlumno.Servicio = this.dPriAlumnoTable.selected[0].priservicio.Iniciales;
                    }
                    this.dPriAlumnoModalDialog = false;
                }
            }
        },
        fuSave(){
            if(!this.$refs.refMain.validate() || this.dTtlTitulacionModalidad.IdAlumno==''){
                this.dSnackbar = true;
            } else {
                if (!this.dIdTitulacionModalidad)
                    this.fuCreate();
                else
                    this.fuUpdate();
            }
        },
        async fuCreate () {
            try {
                this.dIsUpdating = true;
                this.dTtlTitulacionModalidad.IdPersonal = this.ssUser.IdPersonal;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation ttltitulacionmodalidadCreate($input: ttltitulacionmodalidadCreateInput!){
                        ttltitulacionmodalidadCreate(input: $input){
                            idTitulacionModalidad
                        }
                    }`,
                    variables: {
                        input: this.dTtlTitulacionModalidad
                    }
                });
                console.log(response.data);
                if(response.data){
                    this.dIdTitulacionModalidad = response.data.ttltitulacionmodalidadCreate.idTitulacionModalidad;
                    Swal.fire('Correcto', 'Se guardó correctamente', 'success')
                } else {
                    Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dIsUpdating = false;
            }
        },
        async fuUpdate () {
            try {
                this.dIsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation ttltitulacionmodalidadUpdate($idTitulacionModalidad: ID!, $input: ttltitulacionmodalidadUpdateInput!){
                        ttltitulacionmodalidadUpdate(idTitulacionModalidad: $idTitulacionModalidad, input: $input){
                            idTitulacionModalidad
                        }
                    }`,
                    variables: {
                        idTitulacionModalidad: this.dIdTitulacionModalidad,
                        input: this.dTtlTitulacionModalidad
                    }
                });
                console.log(response.data);
                if(response.data){
                    Swal.fire('Correcto', 'Se modificó correctamente', 'success')
                } else {
                    Swal.fire('¡ ERROR !', 'No se modificó.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se modificó.', 'error')
            } finally {
                this.dIsUpdating = false;
            }
        },
        async fuGet(pIdTitulacionModalidad){
            this.dIdTitulacionModalidad = pIdTitulacionModalidad;
            this.dTab='tab-2';
            this.dIsSearch=false;
            try {
                this.dIsUpdating = true;

                const response = await this.$apollo.query({
                    query: gql`query ttltitulacionmodalidad($idTitulacionModalidad: ID!, $token: String){
                        ttltitulacionmodalidad(idTitulacionModalidad:$idTitulacionModalidad, token: $token){
                            documentoEstado
                            notaFinal
                            estadoNota
                            personalResponsable
                            fechaProgramado
                            actaSustentacion
                            nroFut
                            observacion
                            IdAlumno
                            idModalidadTipo
                            prialumno{
                                IdAlumno
                                Alumno
                                DNI
                                Codigo
                                Celular
                                Telefono
                                Sexo
                                priservicio{
                                    Iniciales
                                }
                            }
                        }
                    }`,
                    variables: {
                        idTitulacionModalidad: pIdTitulacionModalidad,
                        token: new Date().toISOString()
                    }
                })
                console.log(response.data);
                if(response.data){
                    this.dTtlTitulacionModalidad.documentoEstado = response.data.ttltitulacionmodalidad.documentoEstado;
                    this.dTtlTitulacionModalidad.notaFinal = response.data.ttltitulacionmodalidad.notaFinal;
                    this.dTtlTitulacionModalidad.estadoNota = response.data.ttltitulacionmodalidad.estadoNota;
                    this.dTtlTitulacionModalidad.personalResponsable = response.data.ttltitulacionmodalidad.personalResponsable;
                    this.dTtlTitulacionModalidad.fechaProgramado = response.data.ttltitulacionmodalidad.fechaProgramado;
                    this.dTtlTitulacionModalidad.actaSustentacion = response.data.ttltitulacionmodalidad.actaSustentacion;
                    this.dTtlTitulacionModalidad.nroFut = response.data.ttltitulacionmodalidad.nroFut;
                    this.dTtlTitulacionModalidad.observacion = response.data.ttltitulacionmodalidad.observacion;
                    this.dTtlTitulacionModalidad.IdAlumno = response.data.ttltitulacionmodalidad.IdAlumno;
                    this.dTtlTitulacionModalidad.IdPersonal = response.data.ttltitulacionmodalidad.IdPersonal;
                    this.dTtlTitulacionModalidad.idModalidadTipo = response.data.ttltitulacionmodalidad.idModalidadTipo.toString();
                    
                    this.dPriAlumno.DNI = response.data.ttltitulacionmodalidad.prialumno.DNI;
                    this.dPriAlumno.Alumno = response.data.ttltitulacionmodalidad.prialumno.Alumno;
                    this.dPriAlumno.Sexo = response.data.ttltitulacionmodalidad.prialumno.Sexo;
                    this.dPriAlumno.Telefono = response.data.ttltitulacionmodalidad.prialumno.Telefono;
                    this.dPriAlumno.Codigo = response.data.ttltitulacionmodalidad.prialumno.Codigo;
                    this.dPriAlumno.Celular = response.data.ttltitulacionmodalidad.prialumno.Celular;
                    this.dPriAlumno.Servicio = response.data.ttltitulacionmodalidad.prialumno.priservicio.Iniciales;
                } else {
                    Swal.fire('¡ ERROR !', 'No se recuperó el registro.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se recuperó el registro.', 'error')
            } finally {
                this.dIsUpdating = false;
            }
        }
    },
    computed: {
        ...mapState(['ssUser']),
        campoTipo: function () {
            if(this.dDNINombre==''){
                return '';
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    return 'DNI';
                else{
                    if(this.dDNINombre.length==9 && !isNaN(this.dDNINombre.substring(0,5)))
                        return 'Codigo';
                    else
                        return 'Nombre';
                }
            }
        }
    }
}
</script>